import type { ReactElement } from 'react'

import { BankIcon } from '@twistopayments/design-system/icons/inline'

import { FormattedDate } from '../../atoms/format'
import { IconCircle } from '../../atoms/icon-circle'
import { Typography } from '../../atoms/typography'
import { Action } from '../action'

type Props = {
  name: ReactElement | string
  cardNumber?: string
  connectedAt?: string
}

export const BankAccountsListItem = ({
  name,
  connectedAt,
  cardNumber,
}: Props) => (
  <Action
    noPadding
    caption={name}
    data-testid="bank-account-item"
    endAdornment={
      connectedAt ? (
        <Typography color="textSecondary" variant="b3">
          <FormattedDate
            date={connectedAt}
            day="numeric"
            month="numeric"
            year="numeric"
          />
        </Typography>
      ) : undefined
    }
    icon={<IconCircle icon={BankIcon} />}
    label={cardNumber}
  />
)
